
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'panel', name: 'Panel Upgrades' },
    { id: 'ev', name: 'EV Chargers' },
    { id: 'potlights', name: 'Potlights' },
    { id: 'commercial', name: 'Commercial' },
    { id: 'residential', name: 'Residential' }
  ];

  const galleryImages = [
    {
      src: 'https://public.readdy.ai/ai/img_res/8fca841e66f8e7406b8892c48b91ed6c.jpg',
      alt: 'Panel Upgrade - Residential',
      category: 'panel'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Tesla%20EV%20charger%20installation%20on%20garage%20wall%2C%20clean%20professional%20installation%2C%20modern%20home%20garage%2C%20bright%20lighting%2C%20completed%20electrical%20work&width=600&height=400&seq=gallery-ev-1&orientation=landscape',
      alt: 'EV Charger Installation',
      category: 'ev'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=LED%20potlight%20recessed%20lighting%20installed%20in%20modern%20living%20room%20ceiling%2C%20even%20bright%20lighting%2C%20professional%20electrical%20installation%2C%20contemporary%20home%20interior&width=600&height=400&seq=gallery-pot-1&orientation=landscape',
      alt: 'Potlight Installation - Living Room',
      category: 'potlights'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Commercial%20electrical%20installation%20in%20office%20building%2C%20professional%20electrical%20work%2C%20modern%20commercial%20setting%2C%20industrial%20electrical%20equipment%2C%20bright%20lighting&width=600&height=400&seq=gallery-comm-1&orientation=landscape',
      alt: 'Commercial Electrical Work',
      category: 'commercial'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Electrical%20panel%20upgrade%20in%20basement%2C%20organized%20electrical%20wiring%2C%20professional%20installation%2C%20residential%20electrical%20work%2C%20clean%20setup&width=600&height=400&seq=gallery-panel-2&orientation=landscape',
      alt: 'Basement Panel Upgrade',
      category: 'panel'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Level%202%20EV%20charging%20station%20installation%2C%20professional%20electrical%20work%2C%20garage%20installation%2C%20modern%20electric%20vehicle%20charger%2C%20clean%20installation&width=600&height=400&seq=gallery-ev-2&orientation=landscape',
      alt: 'Level 2 EV Charger',
      category: 'ev'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Kitchen%20potlight%20installation%2C%20LED%20recessed%20lighting%20in%20kitchen%20ceiling%2C%20modern%20kitchen%20interior%2C%20professional%20electrical%20work%2C%20bright%20even%20lighting&width=600&height=400&seq=gallery-pot-2&orientation=landscape',
      alt: 'Kitchen Potlights',
      category: 'potlights'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Residential%20electrical%20renovation%2C%20new%20outlets%20and%20switches%20installation%2C%20modern%20home%20electrical%20work%2C%20professional%20installation%2C%20clean%20finish&width=600&height=400&seq=gallery-res-1&orientation=landscape',
      alt: 'Residential Renovation',
      category: 'residential'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Outdoor%20electrical%20installation%2C%20exterior%20lighting%20and%20electrical%20work%2C%20professional%20electrical%20service%2C%20house%20exterior%20electrical%20installation%2C%20bright%20daylight&width=600&height=400&seq=gallery-outdoor-1&orientation=landscape',
      alt: 'Outdoor Electrical Work',
      category: 'residential'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Bathroom%20potlight%20installation%2C%20LED%20recessed%20lighting%20in%20bathroom%20ceiling%2C%20modern%20bathroom%20interior%2C%20professional%20electrical%20work%2C%20bright%20clean%20lighting&width=600&height=400&seq=gallery-pot-3&orientation=landscape',
      alt: 'Bathroom Potlights',
      category: 'potlights'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Industrial%20electrical%20panel%20installation%2C%20commercial%20electrical%20work%2C%20large%20electrical%20equipment%2C%20professional%20industrial%20installation%2C%20modern%20electrical%20systems&width=600&height=400&seq=gallery-comm-2&orientation=landscape',
      alt: 'Industrial Panel Installation',
      category: 'commercial'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Home%20electrical%20wiring%20installation%2C%20new%20electrical%20circuits%2C%20professional%20residential%20electrical%20work%2C%20organized%20wiring%2C%20clean%20installation&width=600&height=400&seq=gallery-res-2&orientation=landscape',
      alt: 'Home Wiring Installation',
      category: 'residential'
    }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gray-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Our <span className="text-yellow-400">Work Gallery</span>
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Explore our portfolio of completed electrical projects throughout the GTA. 
                From panel upgrades to EV charger installations, see the quality of our work.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Tabs */}
        <section className="py-8 bg-white border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    selectedCategory === category.id
                      ? 'bg-yellow-400 text-black'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredImages.map((image, index) => (
                <div
                  key={index}
                  className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow bg-white"
                  onClick={() => setSelectedImage(image.src)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                    <i className="ri-zoom-in-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold text-gray-900">{image.alt}</h3>
                  </div>
                </div>
              ))}
            </div>

            {filteredImages.length === 0 && (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">No projects found in this category.</p>
              </div>
            )}
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-yellow-400">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-black mb-4">
              Ready to Start Your Project?
            </h2>
            <p className="text-lg text-gray-800 mb-8 max-w-2xl mx-auto">
              Let us help you with your next electrical project. Contact us today for a free estimate.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/16472873597?text=Hi%20Volt%20Electric!%20I%20saw%20your%20gallery%20and%20would%20like%20to%20get%20a%20free%20estimate%20for%20my%20electrical%20project."
                className="bg-black text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2"
              >
                <i className="ri-whatsapp-fill"></i>
                <span>Get Free Estimate</span>
              </a>
              <a
                href="tel:+16472873597"
                className="bg-white text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2"
              >
                <i className="ri-phone-fill"></i>
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </section>

        {/* Lightbox */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full p-4">
              <img
                src={selectedImage}
                alt="Gallery Image"
                className="max-w-full max-h-full object-contain"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;
